import { render, staticRenderFns } from "./ButtonForm.vue?vue&type=template&id=6bcbee44&scoped=true"
import script from "./ButtonForm.vue?vue&type=script&lang=js"
export * from "./ButtonForm.vue?vue&type=script&lang=js"
import style0 from "./ButtonForm.vue?vue&type=style&index=0&id=6bcbee44&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bcbee44",
  null
  
)

export default component.exports